var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-radio-group",
    {
      attrs: { size: "mini" },
      on: { change: _vm.onChange },
      model: {
        value: _vm.selectedType,
        callback: function ($$v) {
          _vm.selectedType = $$v
        },
        expression: "selectedType",
      },
    },
    _vm._l(_vm.options, function (item, index) {
      return _c(
        "el-radio-button",
        { key: index, attrs: { label: item["key"] } },
        [_vm._v(_vm._s(item["name"]))]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }